/**
 * Mensagem do oplog — a unidade que viaja entre aparelhos (ver docs/features/SYNC.md, ADR 0030).
 *
 * Cada mensagem afirma: "no instante `timestamp` (HLC), a coluna `column` da linha `row` na
 * tabela `table` passou a valer `value`". O motor reconcilia por last-write-wins POR CAMPO —
 * dois aparelhos editando colunas diferentes da mesma linha nunca conflitam.
 *
 * Apagar uma linha é uma mensagem como qualquer outra: coluna sentinela `TOMBSTONE_COLUMN`.
 * Restaurar é a mesma coluna com valor falso e HLC mais novo — o tombstone é uma célula com
 * seu próprio LWW.
 */

export const TOMBSTONE_COLUMN = '__deleted__';

const SEP = ' ';

export interface Message {
    /** HLC empacotado (ver hlc.ts) — a chave de ordenação do last-write-wins. */
    timestamp: string;
    /** Tabela de domínio (dataset). */
    table: string;
    /** id da linha. */
    row: string;
    /** Coluna alterada; `TOMBSTONE_COLUMN` marca/desmarca a linha como apagada. */
    column: string;
    /** Valor JSON-serializável (string | number | boolean | null). */
    value: unknown;
}

/** Identidade exata da mensagem — usada para deduplicar ao unir conjuntos. */
export function messageKey(m: Message): string {
    return `${m.timestamp}${SEP}${m.table}${SEP}${m.row}${SEP}${m.column}`;
}

/** Identidade da CÉLULA (tabela, linha, coluna) — o alvo do last-write-wins. */
export function cellKey(m: Pick<Message, 'table' | 'row' | 'column'>): string {
    return `${m.table}${SEP}${m.row}${SEP}${m.column}`;
}

/** Identidade da LINHA (tabela, linha). */
export function rowKey(m: Pick<Message, 'table' | 'row'>): string {
    return `${m.table}${SEP}${m.row}`;
}

export function isTombstone(m: Message): boolean {
    return m.column === TOMBSTONE_COLUMN;
}
